
        <!-- 交易流水 -->
<template>
  <div class="financeSetA">
    <!-- <vue-scroll :ops="ops" style="width:100%;min-height:100%;"> -->
    <!-- <div class="navCalss">| 订单管理</div> -->

    <div class="navCal">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="所有工单" name="first"></el-tab-pane>
        <el-tab-pane label="待处理" name="second"> </el-tab-pane>
        <el-tab-pane label="处理中" name="third"></el-tab-pane>
        <el-tab-pane label="已处理" name="four"></el-tab-pane>
        <el-tab-pane label="已取消" name="five"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="monewt">
      <el-form :inline="true">
        <div style="margin: 10px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="单号 :">
                <el-input
                  v-model="orderNOA"
                  style="width: 224px"
                  placeholder="输入物流单号/工单号查询" clearable
                  @clear="initData()"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="客户:">
                <el-input
                  v-model="orderNOC"
                  style="width: 224px"
                  placeholder="输入客户名称或vip号查询" clearable
                  @clear="initData()"
                ></el-input>
                <el-button
                  style="margin-left: 20px"
                  @click="getOrderList('1')"
                  type="primary"
                  >查询</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <!-- //表格 -->
    <div class="table_container">
      <el-table
        :data="orderMoney"
        border
        style="width: 100%"
        stripe
        id="printTable"
        ref="table"
      >
        <el-table-column
          label="工单编号"
          prop="orderNo"
          min-width="150px"
          align="center"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.demandNo }}</div>
          </template>
        </el-table-column>

        <el-table-column label="提出时间" min-width="120px" align="center">
          <template slot-scope="scope">
            <div style="display: flex">
              <div style="flex: 8">
                <div>{{ scope.row.createDate }}</div>
              </div>
              <!-- <div style="flex:4;text-align:left" v-if="scope.row.detailList.length>1">
                      <span >...等{{scope.row.productNum}}款</span>	 
                 
                  </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="运单号"
          prop="expressNo"
          min-width="150px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="物流公司"
          prop="expressCompany"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="客户"
          prop="realName"
          min-width="80px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.realName }}
          </template>
        </el-table-column>
        <el-table-column
          label="vip号"
          prop="vipCode"
          min-width="80px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.vipCode }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" min-width="130px" align="center">
          <template slot-scope="scope">
            {{ scope.row.mobile }}
          </template>
        </el-table-column>

        >

        <el-table-column label="状态" min-width="70px" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0" style="color: #d9001b">
              待处理
            </div>
            <div v-else-if="scope.row.status == 1" style="color: #f59a23">
              处理中
            </div>
            <div v-else-if="scope.row.status == 2" style="color: #70b603">
              已处理
            </div>

            <div v-else-if="scope.row.status == -1" style="color: gray">
              已取消
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作人"
          min-width="100px"
          align="center"
          prop="addDate"
        >
          <template slot-scope="scope">
            {{ scope.row.adminPojo ? scope.row.adminPojo.realName : "" }}
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          min-width="130px"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div>
              <el-button type="text" @click="getorderNo(scope.row)"
                >查看</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page="paginations.page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="1000px"
      title="编辑订单"
      center
    >
      <el-form
        :model="order"
        ref="netBarForm"
        label-width="55px"
        style="width: auto"
        label-position="left"
      >
       <div class="wj_dialog_panel">
        <div class="wrl-marign">
          <div class="wel-flex">
            <div>工单号：</div>
            <div>{{ orderInfo.demandNo }}</div>
          </div>
          <div class="wel-flex">
            <div>提交时间：</div>
            <div>{{ orderInfo.createTime }}</div>
          </div>
          <div class="wel-flex">
            <div>快递公司：</div>
            <div>
              {{ orderInfo.expressCompany }}
            </div>
          </div>
          <div class="wel-flex">
            <div>快递单号：</div>
            <div>
              {{ orderInfo.expressNo }}
            </div>
          </div>

          <div class="wel-flex">
            <div>订单状态：</div>
            <div>
              <span v-if="orderInfo.status == 1" style="color: #d9001b">
                待入库
              </span>
              <span v-else-if="orderInfo.status == 2" style="color: #f59a23">
                已入库
              </span>
              <span v-else-if="orderInfo.status == 3" style="color: #70b603">
                已出库
              </span>
              <span v-else-if="orderInfo.status == 4" style="color: #70b603">
                已结单
              </span>

              <span v-else-if="orderInfo.status == -1" style="color: gray">
                已取消
              </span>
            </div>
          </div>

          <div class="wel-flex">
            <div>运输类型：</div>
            <div>
              <span v-if="orderInfo && orderInfo.orderPojo && orderInfo.orderPojo.goodType && (orderInfo.orderPojo.goodType == 1)" style="color: #d9001b">
                海运
              </span>
              <span v-if="orderInfo && orderInfo.orderPojo && orderInfo.orderPojo.goodName && (orderInfo.orderPojo.goodType == 1)" style="color: #d9001b">
                {{orderInfo.orderPojo.goodName}}
              </span>
              <span v-else-if="orderInfo && orderInfo.orderPojo && orderInfo.orderPojo.goodType && (orderInfo.orderPojo.goodType == 2)" style="color: #f59a23">
                海运大件
              </span>
              <span v-if="orderInfo && orderInfo.orderPojo && orderInfo.orderPojo.goodName && (orderInfo.orderPojo.goodType == 2)" style="color: #d9001b">
                {{orderInfo.orderPojo.goodName}}
              </span>
              <span v-else-if="orderInfo && orderInfo.orderPojo && orderInfo.orderPojo.goodType && (orderInfo.orderPojo.goodType == 3)" style="color: #70b603">
                空运
              </span>
              <span v-if="orderInfo && orderInfo.orderPojo && orderInfo.orderPojo.goodName && (orderInfo.orderPojo.goodType == 3)" style="color: #d9001b">
                {{orderInfo.orderPojo.goodName}}
              </span>
            </div>
          </div>

          <div class="linHeight"></div>
          <div class="wel-flex">
            <div>客户名称：</div>
            <div>{{ orderInfo.realName }}</div>
          </div>

          <div class="wel-flex">
            <div>贵宾号：</div>
            <div>{{ orderInfo.vipCode }}</div>
          </div>
          <div class="wel-flex">
            <div>联系方式：</div>
            <div>{{ orderInfo.mobile }}</div>
          </div>
          <div class="wel-flex">
            <div>客户需求：</div>
            <!-- <div>{{order.remark}}</div> -->
            <div v-if="orderInfo.content" style="color: #d9001b">
              {{ orderInfo.content }}
            </div>
            <div v-else>无</div>
          </div>
          <div class="linHeight"></div>
          <div class="wel-flex">
            <div>工单状态：</div>
            <div>
              <el-select
                v-model="orderInfo.workOrderStatus"
                style="width: 208px"
                filterable
              >
                <el-option
                  v-for="item in deliveyList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="wel-flex">
            <div>工单费用：</div>
            <div>
              <el-input
                v-model="orderInfo.demandMoney"
                placeholder="本次工单收费"
                style="width: 208px"
              ></el-input>
            </div>
          </div>
          <!-- <div class="wel-flex">
            <el-input
              type="textarea"
              v-model="orderInfo.reply"
              :rows="5"
              placeholder="请输入给客户的回复"
            ></el-input>
          </div> -->
          <div class="wel-flex" style="margin-top: 20px">
            <div>附件照片：</div>
            <div>
              <div class="wrl-felx6">
                <el-upload
                  class="upload-demo"
                  action=""
                  :headers="headers"
                  :http-request="handleLicenseImgFile"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                >
                  <div class="pta" v-if="productImgA">
                    <i class="el-icon-delete childe" @click.stop="del()"></i>
                    <img
                      :src="productImgACopy"
                      class="avatar"
                      style="width: 81px; height: 46px"
                    />
                  </div>

                  <div v-else>
                    <div class="backgroundA" style="width: 81px; height: 46px">
                      上传
                    </div>
                  </div>
                </el-upload>
              </div>
            </div>

            <div>
              <div class="wrl-felx6" style="margin-left: 20px">
                <el-upload
                  class="upload-demo"
                  action=""
                  :headers="headers"
                  :http-request="handleLicenseImgFileB"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUploadB"
                >
                  <div class="pta" v-if="productImgB">
                    <i class="el-icon-delete childe" @click.stop="delB()"></i>
                    <img
                      :src="productImgBCopy"
                      class="avatar"
                      style="width: 81px; height: 46px"
                    />
                  </div>

                  <div v-else>
                    <div class="backgroundA" style="width: 81px; height: 46px">
                      上传
                    </div>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="flex4">
            <div>
              <el-button
                style="width: 150px"
                type="primary"
                @click="onSubmitOrder()"
                >提交</el-button
              >
            </div>
          </div>
        </div>

        <div class="wj_dialog_right">
            <div class="wj_title">反馈记录</div>
            <div class="wj_content">
               <div :class="item.type==1?'wj_item clear':'wj_item_right clear'" v-for="(item,index) in feedback.list" :key="index">
                 <div><span style="font-size:12px">{{toDate(item.operatorTime)}}</span></div>
                 <el-avatar :size="32" :src="circleUrl" class="wj_avater"></el-avatar>
                 <div class="wj_replay">{{item.content}}</div>
               </div>
                <!-- <div class="wj_item wj_item_right">
                 <el-avatar :size="32" :src="circleUrl"></el-avatar>
                 <div class="wj_replay">挺好的</div>
               </div> -->
            </div>
             
            <div class="wj_bottom">
              	<el-form :model="feedback.data" :rules="feedback.rules" ref="feedbackForm" size="medium">
                  <el-form-item prop="content">
                  <el-input
                    v-model="feedback.data.content"
                    placeholder="回复客户"
                    style="width: 300px;margin-left:20px;"
                  ></el-input>
                  <el-button style="width:100px" type="primary" @click="addFeedback()">发送</el-button>
							   </el-form-item>
               </el-form>
            </div>

        </div>

        </div>
      </el-form>
    </el-dialog>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.showF"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>您确认删除该图片嘛？</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="affirmB()">确认</el-button>
        <el-button type="primary" @click="dialog.showF = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as img from "@/api/img";
import * as workOrder from "@/api/workOrder";
import * as confirm from "@/api/confirm";
// import * as financial from '@/api/financial'
import * as priceGoods from "@/api/priceGoods.js";
import Draggable from "vuedraggable";
import Sortable from "sortablejs";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { axios } from "utils/";
export default {
  components: {
    Draggable,
  },
  data() {
    let demandValidate = (rule, value, callback) => {
      let that = this;
      if (value === "") {
        let text;
        if (rule.field == "content") {
          text = "客户回复";
        }

       return callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    let dataValidate = (rule, value, callback) => {
      let that = this;
      if (value === "") {
        let text;
        if (rule.field == "productWeight") {
          text = "包裹重量";
        } else if (rule.field == "productLong") {
          text = "长度";
        } else if (rule.field == "productWidth") {
          text = "宽度";
        } else if (rule.field == "productHeight") {
          text = "高度";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      circleUrl:"https://cn2ca-1259002481.cos.na-toronto.myqcloud.com/other/avatar-gray.png",
      feedback:{
        data:{
          content:""
        },
        list:[],
        rules: {
          content: [
            { required: true, trigger: "blur", validator: demandValidate },
          ]
        }
      },
      productImgB: "",
      productImgA: "",
      productImgACopy: "",
      productImgBCopy: "",
      tableData: [],
      userIdCode: "",
      //现在时间
      newDate: "",
      //折扣价格
      discountTotal: "",
      priceGoodsIdCopy: {
        firstWeight: "",
        price: "",
        goodId: "",
      },
      priceGoodsId: "",
      priceGoodsList: [],
      indexA: "",
      adminDeleteDialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showF: false,
      },
      delOrderNo: "",
      //表格信息
      deliveyList: [
        {
          value: "待处理",
          id: 1,
        },
        {
          value: "处理中",
          id: 2,
        },
        {
          value: "已处理",
          id: 3,
        },
        {
          value: "已取消",
          id: 0,
        },
      ],
      options: [
        {
          value: "不合箱",
          id: 0,
        },
        {
          value: "合箱",
          id: 1,
        },
      ],
      order: {
        vipCode: "",
        expressCompany: "",
        expressNo: "",
        predictTotal: "",
        isBox: 0,
        remark: "",
        detailList: [
          {
            detailId: 0,
            productName: "",
            productNum: "",
          },
        ],
      },
      pagTotal: false,
      pageIndexB: 0,
      pageIndex: 0,
      orderMoneyB: [],
      orderG: "",
      isBoxG: "",
      orderNOC: "",
      weiBol: false,
      volBol: false,
      galIndex: "",
      galIndexB: "",
      total: 0,
      weiTotal: 0,
      volTotal: 0,
      //图片头
      headers: {},
      orderInfoC: "",
      orderInfo: {
        demandNo: "",

        demandMoney: "",
        demandId: "",
        content: "",
        expressCompany: "",

        expressNo: "",
        realName: "",
        mobile: "",
        vipCode: "",
        status: "",
        workOrderStatus: "",
        reply: "",
      },
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false,
        },
        rail: {
          keepShow: true,
        },
        bar: {
          //  showDelay: 3000,
          hoverStyle: false,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: "#C1C1C1", //滚动条颜色
          keepShow: true,
          size: "12px",
          opacity: 1, //滚动条透明度
        },
      },
      value1: "",
      activeName: "first",

      //全局订单号
      orderNOG: "",
      //现在时间
      NowDate: "",
      //下单时间
      startTime: "",
      endTime: "",
      sytemPrice: "",
      dialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showE: false,
        showF: false,
        showG: false,
        showH: false,
      },
      DataInformation: "",
      orderNOA: "",
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },

      orderMoney: [],

      valueType: 1,
      startDate: "",
      endDate: "",
      form: {
        bankUser: "",

        bankCard: "",
        bankName: "",

        rules: {
          bankName: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
          bankCard: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
          bankUser: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
        },
      },
      productCauserTelist: [], //款目列表存放
      confirmDialogVisible: false,
    };
  },
  created() {
    let that = this;
    // that.getConfig();
    this.newDate = mUtils.formatDate(new Date()).substring(0, 10);
    that.getOrderList();
  },
  methods: {
    initData(){
      this.paginations.page_index=1;
      this.getOrderList()
    },
    addFeedback(){
      let that = this;
      let data = {};

      data.demandNo = that.orderInfo.demandNo;
      data.content = that.feedback.data.content;
      that.$refs.feedbackForm.validate((valid) => {
          if (valid){
               const loading = this.$loading({
                text: "loading",
                spinner: "el-icon-loading",
                background: "rgba(0,0,0,0.7)",
              });
              workOrder.demandFeedback(data).then(function (res) {
                loading.close();
                if (res.data.code != 0) {
                  that.$message({
                    message: res.data.msg || "提交失败",
                    type: "error",
                  });
                  return;
                }
                that.$message({
                    message: "发送成功",
                    type: "succuss",
                });
                that.feedback.data.content="";
                that.getFeedbackList();

              });
          }   
      });
     
    },
    getFeedbackList(){
      let that = this;
      let data = {};
      const loading = this.$loading({
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      data.demandNo = that.orderInfo.demandNo;
      
      workOrder.demandFeedbackList(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return;
        }
        that.feedback.list = res.data.data || [];
      });
    },
    //编辑订单
    //提交表单
    onSubmitOrder() {
      let that = this;
      let data = {};
      // if(!that.orderInfo.demandMoney){
      //   that.$message.warning('请填写工单费用')
      //   return
      // }
      //  if(!that.orderInfo.reply){
      //   that.$message.warning('请填写给客户的回复')
      //   return
      // }
      //  if(!that.orderInfo.productImgB &&!that.orderInfo.productImgA){
      //   that.$message.warning('请填写照片')
      //   return
      // }
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      let img = "";

      if (that.productImgA) {
        img = that.productImgA;
      }
      if (that.productImgB) {
        img = img + "," + that.productImgB;
      }

      data = {
        demandId: that.orderInfo.demandId,
        demandMoney: that.orderInfo.demandMoney,
        status: that.orderInfo.workOrderStatus - 1,
        reply: that.orderInfo.reply,
        replayImg: img,
      };

      workOrder.update(data).then(function (res) {
        if (res.data.code != 0) {
          let msg = "编辑失败";
          that.$message({
            message: msg,
            type: "error",
          });
        } else {
          that.getOrderList();

          that.dialog.show = false;
          let msg = "编辑成功";
          that.$message({
            message: msg,
            type: "success",
          });
          that.getOrderList();
          loading.close();
        }
      });
    },
    affirmB() {
      let that = this;

      let i = that.galIndexB;
      if (i == 1) {
        that.productImgA = "";
        that.productImgACopy = "";
      } else {
        that.productImgB = "";
        that.productImgBCopy = "";
      }
      that.$forceUpdate();
      that.dialog.showF = false;
    },
    del() {
      let that = this;

      that.galIndexB = "1";
      that.dialog.showF = true;
      // that.orderInfo.productList[val].productImg=''
    },
    delB() {
      let that = this;

      that.galIndexB = "2";
      that.dialog.showF = true;
      // that.orderInfo.productList[val].productImg=''
    },
    unploadB(i) {
      let that = this;
      that.galIndex = i;
    },
    unpload(i, index) {
      let that = this;
      that.galIndex = i;
      that.galIndexB = index;
    },
    handleLicenseImgFileB: function (file) {
      let that = this;

      let i = that.galIndex;
      let index = that.galIndexB;

      var formData = new FormData();
      formData.append("file", file.file);
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data",
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            let msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");

          let obj = {};
          that.productImgBCopy = res.data.data.data.path;
          that.productImgB = res.data.data.data.url;

          that.$forceUpdate();

          loading.close();
        }
      });
    },
    beforeAvatarUploadB(file) {
      let isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      const isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },
    handleLicenseImgFile: function (file) {
      let that = this;

      let i = that.galIndex;
      let index = that.galIndexB;
      //              var windowURL = window.URL || window.webkitURL;
      //  this.imageUrl=windowURL.createObjectURL(file.raw);
      var formData = new FormData();
      formData.append("file", file.file);

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data",
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            let msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");
          let obj = {};

          that.productImgACopy = res.data.data.data.path;
          that.productImgA = res.data.data.data.url;
          //  that.imageUrl=res.data.data.realPath
          //    that.imageUrlA=res.data.data.path
          that.$forceUpdate();
          loading.close();
        }
      });
    },
    beforeAvatarUpload(file) {
      let isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      const isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },
    getorderNo(val) {
      let that = this;
      that.productImgB="";
      that.productImgA= "";
      that.productImgACopy="";
      that.productImgBCopy="";

      that.volTotal = 0;
      that.weiTotal = 0;
      // that.getExpressList()
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      let data = {
        demandId: val.demandId,
      };
 
      workOrder.check(data).then((res) => {
        if (res.data.code == 0) {
          that.orderInfo.createTime = mUtils
            .formatDate(new Date(res.data.data.list[0].createTime))
            .substring(0, 10);
          that.orderInfo.demandNo = res.data.data.list[0].demandNo;

          that.orderInfo.demandMoney = res.data.data.list[0].demandMoney || "";
          that.orderInfo.demandId = res.data.data.list[0].demandId;
          that.orderInfo.content = res.data.data.list[0].content || "";
          that.orderInfo.expressCompany =
            res.data.data.list[0].orderPojo.expressCompany;

          that.orderInfo.expressNo = res.data.data.list[0].orderPojo.expressNo;
          that.orderInfo.realName = res.data.data.list[0].usersPojo.realName;
          that.orderInfo.mobile = res.data.data.list[0].usersPojo.mobile;
          that.orderInfo.vipCode = res.data.data.list[0].usersPojo.vipCode;
          that.orderInfo.status = res.data.data.list[0].orderPojo.status;
          that.orderInfo.workOrderStatus = res.data.data.list[0].status + 1;
          that.orderInfo.reply = res.data.data.list[0].reply || "";
          that.orderInfo.orderPojo = res.data.data.list[0].orderPojo;
          if (res.data.data.list[0].replayImg) {
            if (res.data.data.list[0].replayImg.split(",").length > 1) {
              that.productImgA = res.data.data.list[0].replayImg.split(",")[0];
              that.productImgACopy =
                res.data.data.filePath +
                res.data.data.list[0].replayImg.split(",")[0];
              that.productImgB = res.data.data.list[0].replayImg.split(",")[1];
              that.productImgBCopy =
                res.data.data.filePath +
                res.data.data.list[0].replayImg.split(",")[1];
            } else {
              that.productImgA = res.data.data.list[0].replayImg.split(",")[0];
              that.productImgACopy =
                res.data.data.filePath +
                res.data.data.list[0].replayImg.split(",")[0];
            }
          }
          that.getFeedbackList();
          that.$forceUpdate();
          that.dialog.show = true;

         // that.$forceUpdate();
          loading.close();
        }
      });
    },
    handleClick(tab, event) {
      let that = this;

      this.activeName = tab.name;
      that.orderMoneyB = [];
      that.paginations.page_index = 1;
      that.getOrderList();
    },
    getOrderList(dataA) {
      let that = this;
      if (dataA) {
        that.paginations.page_index = 1;
      }
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      let status = 0;
      if (that.activeName == "first") {
        status = "";
      } else if (that.activeName == "second") {
        status = 0;
      } else if (that.activeName == "third") {
        status = 1;
      } else if (that.activeName == "four") {
        status = 2;
      } else if (that.activeName == "five") {
        status = -1;
      }

      let data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        status: status,
        demandNo: that.orderNOA ? that.orderNOA : null,
        realName: that.orderNOC ? that.orderNOC : null,
      };

      workOrder.demandList(data).then((res) => {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              if (val.orderPojo.expressNo) {
                val.expressNo = val.orderPojo.expressNo;
                val.expressCompany = val.orderPojo.expressCompany;
              }
              val.mobile = val.usersPojo.mobile;
              val.realName = val.usersPojo.realName;
              val.vipCode = val.usersPojo.vipCode;
              val.createDate = mUtils
                .formatDate(new Date(val.createTime))
                .substring(0, 10);
            });
            that.orderMoney = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
          } else {
            that.orderMoney = [];
            that.paginations.total = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询订单列表失败");
          } else {
            that.$message.error("获取订单列表失败");
          }
        }
        loading.close();
      });
    },
    toDate(time){
            return mUtils.formatDate(new Date(time),4)
        },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;

      that.paginations.page_size = page_size;

      // 	if(that.searchData.keyWord){
      // that.getproductListLike()
      // 	}else{
      that.getOrderList();
      // }
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      // 		if(that.searchData.keyWord){
      // that.getproductListLike()
      // 	}else{
      that.getOrderList();
      // }
    },
    // },
  },
};
</script>
<style  lang="less" scoped>
.financeSetA::-webkit-scrollbar {
  display: none;
}
.financeSetA {
  margin: 0 50px 50px 50px;
  // width: 900px;
  overflow: hidden;
  .monewt {
    margin: 20px 0px;
    // border: 1px solid rgba(121, 121, 121, 1);
    min-height: 50px;
    min-width: 900px;
  }
}
.pagination {
  margin: 20px 0;
}
.backakdia {
  background: #dcdfe6;
  line-height: 30px;
  min-height: 30px;
}
.ss {
  cursor: pointer;
  color: #409eff;
}
.navCal {
  margin: 20px 0;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.ellipsis {
  // max-width: 150px;
  max-height: 20px;
  //  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.ellipsisB {
  max-width: 580px;
  max-height: 20px;
  // overflow:hidden;
  white-space: nowrap;
  // text-overflow:ellipsis;
  overflow: hidden;
  // white-space: pre-wrap	;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.ellipsisBB {
  max-width: 220px;
  max-height: 20px;
  // overflow:hidden;
  white-space: nowrap;
  // text-overflow:ellipsis;
  overflow: hidden;
  // white-space: pre-wrap	;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.wel-flex {
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 5px 20px;
}
.wrl-hedaNa {
  margin: 10px 0;
}
.wrl-productList {
  margin: 20px 0;
}
.wrl-border {
  height: 2px;
  margin: 20px 0;
  background-color: #d7d7d7;
}
.wj_dialog_panel{
    margin: 0 30px;
    height: 650px;
    position: relative;
    border:1px solid #d7d7d7;

   .wrl-marign {
      width:450px;
      margin: 0;
      padding: 0;
      height:650px;
      border-right: 1px solid #d7d7d7;
   }
   .wj_dialog_right{
     position:absolute;
     left:450px;
     top:0;
     width:440px;
     .wj_title{
       padding: 15px 0;
       width:100%;
       text-align: center;
       font-size:16px;
       font-weight: bold;
       border-bottom: 1px solid #d7d7d7;
     }
     .wj_content{
       padding: 10px;
       height:520px;
       overflow-y: auto;
       .wj_item{
         position: relative;
         padding: 10px 0;
         margin: 0 20px;
         .wj_avater{
           float: left;
         }
         
         .wj_replay{
           font-size:14px;
           background-color: #F2F6FC;
           border-radius: 4px;
           padding: 5px 10px;
           text-align: justify;
           float: left;
           max-width: 300px;
           margin-left: 10px;
         }
       }
       .wj_item_right{
         position: relative;
         padding: 10px 0;
         margin: 0 20px;
         text-align: right;
         .wj_avater{
           float: right;
         }
          .wj_replay{
         
           font-size:14px;
           background-color: #F2F6FC;
           border-radius: 4px;
           padding: 5px 10px;
           text-align: justify;
           float: right;
           max-width: 300px;
           margin-right: 10px;
         }
       }
     }
   }
}

.wrl-flex2 {
  display: flex;
  margin: 10px 0;
  justify-content: start;
  align-items: center;
  .wrl-felx4 {
    width: 340px;
  }
  .wrl-felx44 {
    width: 170px;
  }
  .wrl-felx5 {
    max-width: 700px;
  }
  .wrl-felx6:nth-child(:first) {
    margin-left: 10px;
  }
}
.wrl-felxz {
  margin: 10px 30px;
  display: flex;
  justify-content: space-between;

  .wrl-left {
    flex: 1;
    .wrl-felxz1 {
      display: flex;
    }
  }
}
.lbl_title {
  height: 40px;
  line-height: 40px;
  &.lbl_margin {
    margin-left: 15px;
  }
}
.backgroundA {
  background-image: url("../../assets/img/u38937.svg");
  //  min-height: 80px;
  line-height: 47px;
  width: 81px;
  //  width:50px;
  //   height:50px;
  // margin: 24% 30%;
  // color: white;
  background-repeat: no-repeat;
}
.avatar {
  min-height: 46px;
  width: 81px;
}
.wlr-header {
  display: flex;
  height: 30px;
  line-height: 30px;
  align-items: center;
  justify-content: space-between;
  .wlr-start {
    display: flex;
    justify-content: start;
  }
}
.inpoutTop {
  margin-top: 5px;
  width: 70px;
}
.space {
  margin: 0 5px;
}
.wrl-flex56 {
  display: flex;
  margin-right: 20px;
  justify-content: center;
  font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
  font-weight: 400;
  font-style: normal;
  line-height: 40px;
  height: 40px;
}
.wrl-flex57 {
  // width: 177px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.pta {
  position: relative;
  .childe {
    position: absolute;
    right: -8px;
    top: -10px;
  }
}
.el-icon-delete {
  font-size: 20px;
}
.widthA {
  width: 48px;
}
.widthB {
  width: 150px;
}
.wrl-flex32 {
  display: flex;
  justify-content: flex-end;
  margin-top: -15px;
  .wrl-leftig {
    margin-right: 5vw;
  }
}
.backRed {
  color: #ec808d;
}
.cursor {
  cursor: pointer;
}
.red {
  color: rgb(217, 0, 27) !important;
}
.flex22 {
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  height: 30px;
  align-items: center;
  .font {
    font-family: "PingFangSC-Medium", "PingFang SC Medium", "PingFang SC",
      sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #555555;
    line-height: normal;
    // font-weight: bold;
  }
}
.flex4 {
  display: flex;
  margin-top: 50px;
  justify-content: center;
}
.spaceLeft {
  margin-left: 20px;
}
.lineHeight {
  line-height: 45px;
  height: 45px;
}
.showFlex {
  display: flex;
  justify-content: center;
  line-height: 44px;
  height: 44px;
}
.showFontSize {
  font-size: 18px;
  font-weight: bold;
}
.lineHeightTop {
  height: 1px;
  background: #797979;
  margin: 10px 0 20px 0;
}
.linHeight {
  height: 1px;
  background: #d7d7d7;
  margin: 20px 0;
}
</style>
<style>
.el-table th.gutter {
  display: table-cell !important;
}
.navCal .is-active {
  background-color: rgba(2, 125, 180, 1);
  color: white !important;
}
.inpout .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 30px;
  line-height: 30px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
.bt .el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  /* border: 1px solid #DCDFE6; */
  color: #409eff;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 0 20px;
  font-size: 14px;
  border-radius: 4px;
}
.flex22 .el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  /* background: #FFF;
    border: 1px solid #DCDFE6; */
  /* color: #606266; */
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
}
.addProdauc .el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  /* background: #FFF;
    border: 1px solid #DCDFE6; */
  /* color: #606266; */
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
}
/* .scrt{
         overflow-x:hidden;
         overflow-y:scroll
       } */
</style>



// WEBPACK FOOTER //
// workOrderList.vue?a4012a7a